"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = {
  PROGRAM: 'program',
  ASSIGNMENT: 'assignment',
  PIPELINE: 'pipeline',
  COMMAND: 'command',
  INTERPOLATION: 'interpolation',
  FUNCTION: 'function',
  OPTION: 'option',
  ARGUMENT: 'argument'
};
exports.default = _default;